module.exports = __webpack_public_path__ + "static/media/microphone.26ce5d3b.svg";